import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';
import './SubscriptionCancel.css';

const SubscriptionCancel = () => {
  return (
    <div className="subscription-cancel-page">
      <div className="cancel-container">
        <div className="cancel-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </div>

        <h1>Checkout Cancelled</h1>
        <p className="cancel-message">
          No worries! Your checkout was cancelled and you haven't been charged.
        </p>

        <div className="cancel-actions">
          <Link to="/coach/subscribe">
            <Button variant="primary" size="lg">
              Try Again
            </Button>
          </Link>
          <Link to="/coach/dashboard">
            <Button variant="outline" size="lg">
              Back to Dashboard
            </Button>
          </Link>
        </div>

        <p className="cancel-note">
          Have questions? <a href="mailto:support@threeplates.fit">Contact support</a>
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCancel;
